Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EggheadLesson", {
  enumerable: true,
  get: function get() {
    return _eggheadLesson.EggheadLesson;
  }
});
var _eggheadLesson = require("./egghead-lesson");